module.exports = __webpack_public_path__ + "static/media/puzzlepiece4.da0a92f6.svg";